/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import { MomentCell } from 'backgrid-moment-cell';
import moment from 'moment';
import { MnObject } from 'backbone.marionette';
// import MomentCustomCell from 'psa-backgrid/MomentCustomCell';

export const DateCell = MomentCell.extend({
  displayFormat: 'MM/DD/YYYY' //displayed in UTC by default
});

export const MomentCellEditor = {}; //MomentCustomCell.MomentCellEditor;

export const MomentFormatter = MnObject.extend({
  emptyValue: '--',

  fromRaw(rawValue) {
    const val = moment.isMoment(rawValue) ? rawValue : moment(rawValue, moment.ISO_8601);
    if (_.isNull(val) || !val.isValid() || !this.formatString) {
      return this.emptyValue;
    } else {
      return val.format(this.formatString);
    }
  }
});

export const MomentDateFormatter = MomentFormatter.extend({
  formatString: 'MM/DD/YYYY'
});

export const MomentDateTimeFormatter = MomentFormatter.extend({
  formatString: 'MM/DD/YYYY[&#x200b;] hh:mm[&nbsp;]z'
});

export function MomentSortValue(rowModel, columnName) {
  let cellValue = rowModel.get(columnName);
  // if the cell value is a valid moment object, return the date as the
  // number of milliseconds since the Unix Epoch. Otherwise return -1
  // (always sort first)
  cellValue = moment.isMoment(cellValue) ? cellValue : moment(cellValue, moment.ISO_8601);
  if (cellValue.isValid()) {
    return cellValue.valueOf();
  } else {
    return -1;
  }
}
